import Logo from '../../assets/logo.svg'

import styles from './style.module.scss';

const Header = () => (
  <header className={styles.header}>
    <div className={styles.logo}>
      <img src={Logo} alt="" />
      <span>городской сервис аренды зарядок</span>
    </div>
  </header>
)

export default Header;